import { createAction } from 'typesafe-actions';

export const setDemoUser = createAction('user/SET_DEMO_USER');
export const signInSuccess = createAction('user/SIGN_IN_SUCCESS');
